<script setup>
import {getUrlTarget, isFullUrl} from '~/utils/linkUtils'

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const loading = ref(false)

const blockContent = computed(() => props.data.content)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})
function getItemTarget(item) {
  return getUrlTarget(item.url)
}
</script>

<template>
  <div
    class="grid grid-cols-12 bg-[#dcd6ce] text-[#363330] text-[0.8rem] italic lg:text-lg text-center gap-4 px-4 pb-14"
    :class="containerClasses"
    >
    <div class="col-span-12 lg:col-span-6 lg:col-start-4 pb-3 px-4 lg:px-0 grid grid-cols-12 my-4">
      <template v-for="(item, index) in blockContent.items" :key="index">
        <a
          v-if="isFullUrl(item?.url)"
          class="col-span-12 sm:col-span-6 pb-2"
          :href="item.url"
          :target="getItemTarget(item)"
        >
          {{ item.title }}
        </a>
        <NuxtLink
          v-else
          class="col-span-12 sm:col-span-6 pb-2"
          :to="item.url"
        >
          {{ item.title }}
        </NuxtLink>
      </template>
    </div>
  </div>
</template>
